import { useEffect, useState } from 'react'
import { compressImage, convertToBase64, GetAllSchoolsByLocation, getpostalcodes, ymdToDate, YYYYMMDD } from '../../JS/Common';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import { ApiCmnHeadersPostCall } from '../../JS/Connector';
import PageHead from '../../Components/PageHead';
import { useNavigate } from 'react-router-dom';
import { log } from '../../JS/Logger';
import CustomReactDatePicker from '../../Components/CustomReactDatePicker';


export default function Expresstechform({ closePopup }) {
    const navigate = useNavigate();
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [allData, setAllData] = useState({
        UserType: 2,
        CompanyName: "",
        RegisterDate: new Date().toISOString().split('T')[0],
        CustomFeature: 0,
        Email: "",
        PartSKUDoc: "",
        PartSKUDocName: "",
        PrimaryText: "",
        SecondaryText: "",
        PrimaryColor: "#3cbba5",
        SecondaryColor: "#4c5258",
        Logo: "",
        shoppingLink: '',
        defaultLocation: '',
        shipping_client_id: '',
        shipping_secrete_id: '',
        shipping_address_line_1: '',
        shipping_address_line_2: '',
        shipping_city: '',
        shipping_state: '',
        shipping_zipcode: '',
        WebUrl: '',
        fedex_client_id: '',
        fedex_secrete_id: '',
        fedex_phone_no: ''
    });
    const [Locations, setLocations] = useState([]);
    const [AllState, setallstate] = useState([]);
    const [FileValidationError, setFileValidationError] = useState({});

    function handlePartSKU(e) {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "csv", maxSizeMB: 5 })
        if (!isFileValid) {
            setFileValidationError((prev) => ({ ...prev, ["csv"]: validationMsg }));
            setAllData({ ...allData, PartSKUDoc: "", PartSKUDocName: "" });
            e.target.value = "";
            return;
        }
        setFileValidationError((prev) => ({ ...prev, ["csv"]: "" }));
        const reader = new FileReader();
        reader.onload = function (event) {
            setAllData({ ...allData, PartSKUDoc: file, PartSKUDocName: file.name });
        };
        reader.readAsDataURL(file);
        e.target.value = "";
    };
    async function handleLogoUpload(e) {
        setAllData({ ...allData, Logo: '' });
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "image", maxSizeMB: 2 });
        if (!isFileValid) {
            setFileValidationError((prev) => ({ ...prev, ["image"]: validationMsg }));
            setAllData({ ...allData, Logo: '' });
            e.target.value = "";
            return;
        }
        setFileValidationError((prev) => ({ ...prev, ["image"]: "" }));
        const compressedImg = await compressImage(file);
        const base64 = await convertToBase64(compressedImg);
        setAllData({ ...allData, Logo: base64 });
        e.target.value = "";
    };
    const handleSave = async () => {
        var isFormValid = CheckValidation({ formID: 'Expresstechform' });
        if (!isFormValid) return;
        setLoading(true);

        const formdata = new FormData();
        formdata.append('primaryColor', allData.PrimaryColor);
        formdata.append('secondaryColor', allData.SecondaryColor);
        formdata.append('primaryText', allData.PrimaryText);
        formdata.append('secondaryText', allData.SecondaryText);
        formdata.append('name', allData.CompanyName);
        formdata.append('rocket_url', null);
        formdata.append('registerDate', allData.RegisterDate);
        formdata.append('customFeatures', allData.CustomFeature);
        formdata.append('adminEmail', allData.Email);
        formdata.append('partSKUDocument', allData.PartSKUDoc || null);
        formdata.append('location', allData.defaultLocation);
        formdata.append('shoppingLink', allData.shoppingLink);
        formdata.append('shippingClientId', allData.shipping_client_id);
        formdata.append('shippingSecreteId', allData.shipping_secrete_id);
        formdata.append('shippingAddressLine1', allData.shipping_address_line_1);
        formdata.append('shippingAddressLine2', allData.shipping_address_line_2);
        formdata.append('shippingCity', allData.shipping_city);
        formdata.append('shippingState', allData.shipping_state);
        formdata.append('shippingZipcode', allData.shipping_zipcode);
        formdata.append('webUrl', allData.WebUrl);
        formdata.append('fedexClientId', allData.fedex_client_id);
        formdata.append('fedexSecreteId', allData.fedex_secrete_id);
        formdata.append('fedexPhoneNumber', allData.fedex_phone_no);
        formdata.append('logo', allData.Logo || null);

        ApiCmnHeadersPostCall(`/enterprise/client-basic-details`, formdata, false, true)
            .then(result => {
                const responseRs = JSON.parse(result);
                if (responseRs.message == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Client Created Successfully."} />);
                    setTimeout(function () {
                        setNewAlerts(<AlertsComp show={false} />)
                        navigate('/reseller-group')
                    }, 2500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.message} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                setLoading(false);
            })
            .catch(error => log.error('error', error));
    }
    async function handleNewAPI(url) {
        const formdata = new FormData();
        formdata.append('primary_color', allData.PrimaryColor);
        formdata.append('secondary_color', allData.SecondaryColor);
        formdata.append('primary_text', allData.PrimaryText);
        formdata.append('secondary_text', allData.SecondaryText);
        formdata.append('register_date', allData.RegisterDate);
        formdata.append('custom_features', allData.CustomFeature);
        formdata.append('logo', allData.Logo || null);
        formdata.append('admin_email', allData.Email);
        formdata.append('name', allData.CompanyName);
        formdata.append('shopping_link', allData.shoppingLink);
        formdata.append('location', allData.defaultLocation);
        // formdata.append('shipping_client_id', allData.shipping_client_id);
        formdata.append('shipping_address_line_1', allData.shipping_address_line_1);
        formdata.append('shipping_address_line_2', allData.shipping_address_line_2);
        formdata.append('shipping_city', allData.shipping_city);
        formdata.append('shipping_state', allData.shipping_state);
        formdata.append('shipping_zipcode', allData.shipping_zipcode);
        formdata.append('WebUrl', allData.WebUrl);
        formdata.append('fedex_client_id', allData.fedex_client_id);
        formdata.append('fedex_secrete_id', allData.fedex_secrete_id);
        formdata.append('fedex_phone_no', allData.fedex_phone_no);
        formdata.append('PartSKUDoc', allData.PartSKUDoc || null);

        ApiCmnHeadersPostCall(`/enterprise/client-backend-details`, formdata, false, true)
            .then(result => {
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Form Submitted Successfully."} />);
                    setTimeout(function () {
                        setNewAlerts(<AlertsComp show={false} />)
                        window.location.reload();
                    }, 2500);
                }
            })
            .catch(error => log.error('error', error));
    }
    useEffect(() => {
        getpostalcodes(setallstate);
        GetAllSchoolsByLocation({ setLocations })
    }, []);
    return (
        <div className="GridBox mt-2 p-3">
            <div className='greyBox'>
                <PageHead heading={"Add MSP"} loading={loading} Alerts={NewAlerts} />
                <div className="row parent" id='Expresstechform'>
                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Company Name<label className='redText'>*</label></div>
                        <div className='col-md-5'>
                            <input type="text" autoComplete='off' name='companyname' required
                                className="form-control" value={allData.CompanyName}
                                onChange={(e) => setAllData({ ...allData, CompanyName: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>

                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Email<label className='redText'>*</label></div>
                        <div className='col-md-5'>
                            <input type="text" autoComplete='off' name='email' required
                                className="form-control" value={allData.Email}
                                onChange={(e) => setAllData({ ...allData, Email: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>

                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Register Date<label className='redText'>*</label></div>
                        <div className='col-md-5'>
                            <CustomReactDatePicker
                                isRequired="true"

                                selectedDate={allData.RegisterDate ? ymdToDate(allData.RegisterDate) : null}

                                onChangeHandler={(date) => setAllData({ ...allData, RegisterDate: date ? YYYYMMDD(date) : "" })}
                                placeholderText="MM-DD-YYYY"
                            />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>

                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Need any custom features?<label className='redText'>*</label></div>
                        <div className='col-md-5 d-flex'>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name='CustomFeature'
                                    checked={allData.CustomFeature == 1}
                                    onChange={(e) => setAllData({ ...allData, CustomFeature: 1 })} />
                                <label className="form-check-label">
                                    Yes
                                </label>
                            </div>
                            <div className="form-check ms-5">
                                <input className="form-check-input" type="radio" name='CustomFeature'
                                    checked={allData.CustomFeature == 0}
                                    onChange={(e) => setAllData({ ...allData, CustomFeature: 0 })} />
                                <label className="form-check-label">
                                    No
                                </label>
                            </div>

                        </div>
                    </div>

                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Shopping link for your site </div>
                        <div className='col-md-5'>
                            <input type="text" autoComplete='off' name='shoppingLink'
                                className="form-control" value={allData.shoppingLink}
                                onChange={(e) => setAllData({ ...allData, shoppingLink: e.target.value })} />
                        </div>
                    </div>

                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Default Location</div>
                        <div className='col-md-5'>
                            <select value={allData?.defaultLocation} onChange={(e) => setAllData({ ...allData, defaultLocation: e.target.value })} >
                                <option value="0">Select</option>
                                {Locations.map((locationItem, j) => (
                                    <option value={locationItem.id} key={j}>
                                        {locationItem.locationName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Primary Text<label className='redText'>*</label></div>
                        <div className='col-md-5'>
                            <input type="text" autoComplete='off' name='primarytext' required
                                className="form-control" value={allData.PrimaryText}
                                onChange={(e) => setAllData({ ...allData, PrimaryText: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>

                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Secondary Text<label className='redText'>*</label></div>
                        <div className='col-md-5'>
                            <input type="text" autoComplete='off' name='secondarytext' required
                                className="form-control" value={allData.SecondaryText}
                                onChange={(e) => setAllData({ ...allData, SecondaryText: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>

                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Primary Color<label className='redText'>*</label></div>
                        <div className='col-md-5'>
                            <input type="color" name='primarycolor'
                                className="form-control form-control-color"
                                value={allData.PrimaryColor}
                                onChange={(e) => setAllData({ ...allData, PrimaryColor: e.target.value })} />
                        </div>
                    </div>

                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Secondary Color<label className='redText'>*</label></div>
                        <div className='col-md-5'>
                            <input type="color" name='secondarycolor'
                                className="form-control form-control-color"
                                value={allData.SecondaryColor}
                                onChange={(e) => setAllData({ ...allData, SecondaryColor: e.target.value })} />
                        </div>
                    </div>
                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Web URL<label className='redText'>*</label></div>
                        <div className='col-md-5'>
                            <input type="text" autoComplete='off' name='secondarytext' required
                                className="form-control" value={allData.WebUrl}
                                onChange={(e) => setAllData({ ...allData, WebUrl: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>
                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Part SKU List</div>
                        <div className='col-md-5'>
                            <input type="file" label="img" id="partList" name="myFile" accept='.csv' onChange={(e) => handlePartSKU(e)} />
                            <label className="supportTicketbtn col-md-12" htmlFor="partList" style={{ color: "#909091" }}>
                                Choose File
                            </label>
                            {allData.PartSKUDocName && <label className="ps-2 mt-1" style={{ fontWeight: "600", color: '#3CBBA5', wordBreak: 'break-all' }}>{allData.PartSKUDocName} </label>}
                            {FileValidationError?.csv?.trim() != "" && <div className='redText'>{FileValidationError.csv}</div>}
                        </div>
                    </div>
                    <div className='col-md-6 row align-items-center pt-3'>
                        <div className='col-md-7 FormLabel'>Upload Logo</div>
                        <div className='col-md-5'>
                            <form className="col-12">
                                <input type="file" label="Image" name="myFile" accept=".jpg,.png,.jpeg"
                                    id="UploadFileId" onChange={(e) => handleLogoUpload(e)} />
                                <label className="ImportInventoryBtn col-md-7 col-9" htmlFor="UploadFileId">Upload logo</label>
                                <label className="ImportInventoryBtn1 col-md-5 col-3 text-center" htmlFor="UploadFileId" style={{ color: "white" }}>
                                    Browse
                                </label>
                            </form>
                            {FileValidationError?.image?.trim() != "" && <div className='redText'>{FileValidationError.image}</div>}
                        </div>
                    </div>
                    {allData.Logo &&
                        <div className={`col-md-12 pt-4`}>
                            <img src={allData.Logo} alt="logo" className="img-fluid" style={{ maxHeight: "200px", maxWidth: "200px" }} />
                        </div>
                    }

                    <div className='pt-4 font-16 fw-600'>Shipping Details :  </div>
                    <div className='row'>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>Client Id</div>
                            <div className='col-md-5'>
                                <input type="text" autoComplete='off' name='clientId'
                                    className="form-control" value={allData.shipping_client_id}
                                    onChange={(e) => setAllData({ ...allData, shipping_client_id: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>Secret Id</div>
                            <div className='col-md-5'>
                                <input type="text" autoComplete='off' name='secreteId'
                                    className="form-control" value={allData.shipping_secrete_id}
                                    onChange={(e) => setAllData({ ...allData, shipping_secrete_id: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>Street Line 1</div>
                            <div className='col-md-5'>
                                <input type="text" autoComplete='off' name='lin1'
                                    className="form-control" value={allData.shipping_address_line_1}
                                    onChange={(e) => setAllData({ ...allData, shipping_address_line_1: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>Street Line 2</div>
                            <div className='col-md-5'>
                                <input type="text" autoComplete='off' name='line2'
                                    className="form-control" value={allData.shipping_address_line_2}
                                    onChange={(e) => setAllData({ ...allData, shipping_address_line_2: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>City</div>
                            <div className='col-md-5'>
                                <input type="text" autoComplete='off' name='city'
                                    className="form-control" value={allData.shipping_city}
                                    onChange={(e) => setAllData({ ...allData, shipping_city: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>State</div>
                            <div className='col-md-5'>
                                <select name='state' onChange={(e) => setAllData({ ...allData, shipping_state: e.target.value })} >
                                    <option value="0">Select</option>
                                    {AllState.map((item, i) => {
                                        return <option key={i} value={item.state_code} selected={allData.shipping_state == item.state_code}>{item.state_code}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>Zip Code</div>
                            <div className='col-md-5'>
                                <input type="text" autoComplete='off' name='zipcode'
                                    className="form-control" value={allData.shipping_zipcode}
                                    onChange={(e) => setAllData({ ...allData, shipping_zipcode: e.target.value })} />
                            </div>
                        </div>
                    </div>


                    <div className='pt-4 font-16 fw-600'>FedEx Details :  </div>
                    <div className='row'>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>Client Id</div>
                            <div className='col-md-5'>
                                <input type="text" autoComplete='off' name='fclientId'
                                    className="form-control" value={allData.fedex_client_id}
                                    onChange={(e) => setAllData({ ...allData, fedex_client_id: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>Secret Id</div>
                            <div className='col-md-5'>
                                <input type="text" autoComplete='off' name='fsecreteId'
                                    className="form-control" value={allData.fedex_secrete_id}
                                    onChange={(e) => setAllData({ ...allData, fedex_secrete_id: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-6 row align-items-center pt-3'>
                            <div className='col-md-7 FormLabel'>Phone No.</div>
                            <div className='col-md-5'>
                                <input type="number" autoComplete='off' name='fphoneno' min={0}
                                    className="form-control" value={allData.fedex_phone_no}
                                    onChange={(e) => setAllData({ ...allData, fedex_phone_no: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                            e.preventDefault();
                                        }
                                    }} />
                            </div>
                        </div>
                    </div>
                    <div className="pt-4 d-flex align-items-center justify-content-center">
                        <label className="mx-2 cursor-pointer" onClick={(e) => { navigate('/reseller-group') }}><u>Cancel</u></label>
                        <button className="SaveBtn" onClick={handleSave}>Save Details</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
